"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/OverlayPositioning
 */

/**
 * Overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, `'top-right'`
 * @enum {string}
 */
var _default = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
  CENTER_LEFT: 'center-left',
  CENTER_CENTER: 'center-center',
  CENTER_RIGHT: 'center-right',
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7OztlQU1lO0VBQ2JBLFdBQVcsRUFBRSxhQURBO0VBRWJDLGFBQWEsRUFBRSxlQUZGO0VBR2JDLFlBQVksRUFBRSxjQUhEO0VBSWJDLFdBQVcsRUFBRSxhQUpBO0VBS2JDLGFBQWEsRUFBRSxlQUxGO0VBTWJDLFlBQVksRUFBRSxjQU5EO0VBT2JDLFFBQVEsRUFBRSxVQVBHO0VBUWJDLFVBQVUsRUFBRSxZQVJDO0VBU2JDLFNBQVMsRUFBRTtBQVRFLEMiLCJuYW1lcyI6WyJCT1RUT01fTEVGVCIsIkJPVFRPTV9DRU5URVIiLCJCT1RUT01fUklHSFQiLCJDRU5URVJfTEVGVCIsIkNFTlRFUl9DRU5URVIiLCJDRU5URVJfUklHSFQiLCJUT1BfTEVGVCIsIlRPUF9DRU5URVIiLCJUT1BfUklHSFQiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL092ZXJsYXlQb3NpdGlvbmluZy5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==